/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';

import { updateOrderDetailInfoAction } from '../../../actions/order';

class Order05DeliveryItemOrVehicleTypesSG extends React.Component {
  static propTypes = {
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    modelData: PropTypes.shape().isRequired,
    serviceTypes: PropTypes.string.isRequired,
  };

  onClickToggleType(e) {
    this.props.updateOrderDetailInfoAction('vehicle', null, e.target.value);
    // if (e.target.value.split(',')[0] === 'Parcel') {
    //   this.props.updateOrderDetailInfoAction('goods', null, e.target.value.split(',')[0]);
    //   this.props.updateOrderDetailInfoAction('vehicle', null, 'sedan');
    //   this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'additional_cartons', 1);
    // } else {
    //   this.props.updateOrderDetailInfoAction('goods', null, e.target.value.split(',')[0]);
    //   this.props.updateOrderDetailInfoAction('vehicle', null, e.target.value.split(',')[1]);
    //   this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
    // }
  }

  onClickToggleItemType(e) {
    this.props.updateOrderDetailInfoAction('goods', null, e.target.value);
  }

  getTypesDetailOption() {
    // this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
    if (this.props.serviceTypes === 'delivery') {
      return this.props.modelData.goods_types;
    }
    return [];
  }

  render() {
    return (
      <Row>
        <Col md="12" xs="12">
          <div className={s2.orderSmallTitle}>
            {this.props.modelDataText.order.order_goods_title}
          </div>
        </Col>
        <Col md="12" xs="12">
          <select
            className={`${s2.inputSelect} ${s2.backgroundDark} ${
              s2.simpleSelectDropdown
            } ${s2.icon} ${s.orderSelectHover} col-12`}
            onChange={e => {
              this.onClickToggleType(e);
            }}
          >
            {this.props.modelData.vehicle_types.map((v, index) => (
              <option
                key={index.toString()}
                value={v.type}
                defaultValue={index === 0 ? '' : false}
              >
                {v.title}
              </option>
            ))}
          </select>
        </Col>
      </Row>
    );
  }
}
const mapState = state => ({
  images: state.order.images,
  orderDetailInfo: state.order.orderDetailInfo,
});
const mapDispatch = {
  updateOrderDetailInfoAction,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order05DeliveryItemOrVehicleTypesSG),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order05Type/Order05VehicleTypesSG.js